import {
  PiAddressBook,
  PiAlarm,
  PiBuildings,
  PiEnvelopeOpen,
  PiFileText,
  PiFlowArrow,
  PiHandCoins,
  PiHandshake,
  PiLightningA,
  PiMegaphone,
  PiNotepad,
  PiPencilSimple,
  PiPlus,
  PiSealPercent,
  PiShippingContainer,
  PiSparkle,
  PiTag,
  PiTrash,
  PiTruck,
} from 'react-icons/pi'
import { EventIconProps } from './types'

const AUTOMATION_USER_NAMES = new Set(['First Bite Automation'])
// Events whose source is the homepage AI recommendations surface. Adjust
// these strings if backend uses a different user_name for those updates.
const AI_RECOMMENDATION_USER_NAMES = new Set([
  'First Bite AI',
  'AI Recommendation',
  'AI Recommendations',
])

export function EventIcon({
  contentType,
  actionType,
  userName,
}: EventIconProps) {
  const iconClass = 'w-5 h-5 text-green-700'

  // Automation events use the lightning icon regardless of what was
  // changed — they're system-triggered, not user-triggered.
  if (userName && AUTOMATION_USER_NAMES.has(userName)) {
    return <PiLightningA className={iconClass} />
  }

  // AI-generated updates (from the homepage recommendations surface)
  // get a sparkle icon.
  if (userName && AI_RECOMMENDATION_USER_NAMES.has(userName)) {
    return <PiSparkle className={iconClass} />
  }

  if (actionType === 'DELETE') {
    return <PiTrash className={iconClass} />
  }

  if (actionType === 'ADD' || actionType === 'REMOVE') {
    switch (contentType.model) {
      case 'contactcompany':
        return <PiBuildings className={iconClass} />
      case 'contact':
        return <PiAddressBook className={iconClass} />
      default:
        return <PiPlus className={iconClass} />
    }
  }

  switch (contentType.model) {
    case 'campaign':
      return <PiMegaphone className={iconClass} />
    case 'tag':
      return <PiTag className={iconClass} />
    case 'deal':
      return <PiHandshake className={iconClass} />
    case 'companynote':
    case 'note':
    case 'contactnote':
    case 'doornote':
    case 'dealnote':
      return <PiNotepad className={iconClass} />
    case 'reminder':
      return <PiAlarm className={iconClass} />
    case 'contactcompany':
      return <PiBuildings className={iconClass} />
    case 'contact':
      return <PiAddressBook className={iconClass} />
    case 'distributor':
      return <PiTruck className={iconClass} />
    case 'gpo':
      return <PiShippingContainer className={iconClass} />
    case 'sample':
    case 'samplerequest':
      return <PiHandCoins className={iconClass} />
    case 'rebate':
    case 'rebateoffer':
    case 'rebateofferterms':
    case 'rebatesubmission':
      return <PiSealPercent className={iconClass} />
    case 'emailmessage':
      return <PiEnvelopeOpen className={iconClass} />
    case 'document':
      return <PiFileText className={iconClass} />
    default:
      if (actionType === 'UPDATE') {
        return <PiPencilSimple className={iconClass} />
      }
      return <PiFlowArrow className={iconClass} />
  }
}
